


import React from 'react'
import './Community.css'





const Community:React.FC = () => {


    
  return (
    <>
        <div className=' w-screen overflow-hidden p-10 custom-community-container '>
            <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
                <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl text-black font-sans '>
                    <h3>Community Outreach</h3>
                    </div>

                    <div className=' sm:text-lg md:text-lg lg:text-xl xl:text-xl text-black text-center font-mono w-[80%] mt-10'>
                        <p>Next Play Nation is committed to giving back through food drives,
                             school supply giveaways, and free access to sports programming.</p>
                    </div>

            </div>
        </div>
    
    
    
    
    </>
  )
}

export default Community
